import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./DropdownProfile.css";

const DropdownProfile = () => {
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem("idToken") !== null; // Check if user is logged in

  const handleClick = () => {
    // Remove session keys but preserve fb_saved_email (so Facebook users
    // aren't asked for their email again) and theme preference
    localStorage.removeItem("idToken");
    localStorage.removeItem("email");
    localStorage.removeItem("displayName");
    navigate("/login"); // Redirect to login
  };

  const openLikedStories = () => {
    window.location.href = `/LikedStories`;
  };

  const openProfile = () => {
    window.location.href = `/Profile`;
  };

  const openMyStories = () => {
    window.location.href = `/my-stories`;
  };

  return (
    <div className="dropdownprofile">
      <div className="lis first" onClick={openProfile}>
        Profile
      </div>
      <div className="lis" onClick={openMyStories}>
        My Stories
      </div>
      <div className="lis" onClick={openLikedStories}>
        Liked Stories
      </div>
      <div className="lis">
        <Link to="/about">About Us</Link>
      </div>

      {/* If user is logged in, show 'Logout'. If not, show 'Login'. */}
      <div className="lis">
        {isLoggedIn ? (
          <span onClick={handleClick}>Logout</span>
        ) : (
          <Link to="/login">Login</Link>
        )}
      </div>
    </div>
  );
};

export default DropdownProfile;
